import { type Amenity, AMENITIES } from "~/lib/api";

export { type Amenity, AMENITIES };

export const AMENITY_LABELS: Record<Amenity, string> = {
  "bike-storage": "Bike storage",
  kitchen: "Basic kitchen",
  "fully-furnished-kitchen": "Fully furnished kitchen",
  "washer-dryer": "Washer & dryer",
  "washer-drying-rack": "Washer & drying rack",
  "free-parking-premises": "Free parking on premises",
  "paid-parking-premises": "Paid parking on premises",
  "air-conditioner": "Air conditioner",
  "towels-soap": "Towels & soap",
  television: "Television",
  elevator: "Elevator",
  "smart-lock": "Smart lock",
  "outdoor-pool": "Outdoor pool",
  fireplace: "Fireplace",
};
